import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PhoneSecondaryIcon = (props) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.92878 4.92902C1.03969 8.81811 1.03969 15.1821 4.92878 19.0712C8.81787 22.9602 15.1818 22.9602 19.0709 19.0712C22.96 15.1821 22.96 8.81811 19.0709 4.92902C15.1818 1.03994 8.81787 1.03994 4.92878 4.92902ZM14.8199 13.7761L16.3319 13.9501C16.9379 14.0221 17.3939 14.5321 17.3939 15.1441V16.1821C17.3939 16.8601 16.8299 17.4241 16.1519 17.3821C13.5905 17.2231 11.2871 16.1197 9.58372 14.4163C7.88032 12.7129 6.77692 10.4095 6.61792 7.8481C6.57592 7.1701 7.13992 6.6061 7.81792 6.6061H8.85592C9.46792 6.6061 9.97792 7.0621 10.0499 7.6681L10.2239 9.1801C10.2659 9.5461 10.1399 9.9061 9.88192 10.1641L8.77192 11.2741C9.20392 12.1255 9.76732 12.8977 10.4351 13.5649C11.1023 14.2327 11.8745 14.7961 12.7259 15.2281L13.8359 14.1181C14.0939 13.8601 14.4539 13.7341 14.8199 13.7761Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PhoneSecondaryIcon.propTypes = {
  sx: PropTypes.object,
};

export default PhoneSecondaryIcon;
